import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertCritical16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm-1 7c0-.6.4-1 1-1s1 .4 1 1v13c0 .6-.4 1-1 1s-1-.4-1-1V7zm1 19.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" fill="#f24e4e"/>
    ]
  getViewBox = () => '0 0 32 32'
}
